"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.baseSet = void 0;
const __1 = require("../../");
exports.baseSet = [
    // NEUTRALS
    // 1 POTASSIUM
    {
        name: 'Camo Ban',
        description: 'Has camo for one turn',
        potassium: 1,
        attack: 2,
        health: 2,
        type: __1.GameCardTypes.CREATURE,
        modifiers: {
            Camo: true,
        },
        trigger: {
            name: __1.Triggers.TurnStartTrigger,
            once: true,
            effect: {
                name: 'ModifierEffect',
                params: {
                    modifier: 'Camo',
                    value: false,
                },
                targets: {
                    select: __1.TargetSelect.Auto,
                    type: [__1.TargetTypes.Self],
                },
            },
            condition: {
                player: 'SELF',
            },
        },
    },
    {
        name: 'Impatient Chimp',
        description: 'Instant: Deal one damage to any enemy',
        potassium: 1,
        attack: 1,
        health: 2,
        type: __1.GameCardTypes.CREATURE,
        instant: {
            name: 'DamageEffect',
            params: {
                value: 1,
            },
            targets: {
                select: __1.TargetSelect.ByPlayer,
                type: [__1.TargetTypes.EnemyCreature, __1.TargetTypes.EnemyMonkey],
            },
            filterDamageModifiers: true,
        },
    },
    {
        name: 'Coco Blocker',
        description: 'Blocker',
        potassium: 1,
        attack: 2,
        health: 2,
        type: __1.GameCardTypes.CREATURE,
        modifiers: {
            Blocker: true,
        },
    },
    {
        name: 'Boomer Investor',
        description: 'Blocker',
        potassium: 1,
        attack: 1,
        health: 3,
        type: __1.GameCardTypes.CREATURE,
        modifiers: {
            Blocker: true,
        },
    },
    {
        name: 'Moderate Tipper',
        description: 'Instant: Give 1 health to any friendly',
        potassium: 1,
        attack: 1,
        health: 3,
        type: __1.GameCardTypes.CREATURE,
        instant: {
            name: 'BuffEffect',
            params: {
                health: 1,
            },
            targets: {
                select: __1.TargetSelect.ByPlayer,
                type: [__1.TargetTypes.FriendlyCreature],
            },
        },
    },
    {
        name: 'Peel Head Monkey',
        description: 'Monkeshield',
        potassium: 1,
        attack: 1,
        health: 1,
        type: __1.GameCardTypes.CREATURE,
        modifiers: {
            Monkeshield: true,
        },
    },
    {
        name: 'Hippie Investor',
        description: 'High',
        potassium: 1,
        attack: 2,
        health: 3,
        type: __1.GameCardTypes.CREATURE,
        modifiers: {
            High: true,
        },
    },
    {
        name: 'Healthy Milkshake',
        description: 'Give 2 attack to a creature for this turn',
        potassium: 1,
        type: __1.GameCardTypes.SPELL,
        spell: {
            name: 'BuffForTurnEffect',
            params: {
                attack: 2,
            },
            targets: {
                select: __1.TargetSelect.ByPlayer,
                type: [__1.TargetTypes.FriendlyCreature],
            },
        },
        trigger: {
            name: __1.Triggers.TurnEndTrigger,
            once: true,
            effect: {
                name: 'BuffEffect',
                params: {
                    attack: -2,
                },
                targets: {
                    select: __1.TargetSelect.Auto,
                    type: [__1.TargetTypes.Self],
                },
            },
            condition: {
                player: 'SELF',
            },
        },
    },
    {
        name: 'Pointy Banana',
        description: 'Deal 2 damage to any enemy',
        potassium: 1,
        type: __1.GameCardTypes.SPELL,
        spell: {
            name: 'DamageEffect',
            params: {
                value: 2,
            },
            targets: {
                select: __1.TargetSelect.ByPlayer,
                type: [__1.TargetTypes.EnemyCreature, __1.TargetTypes.EnemyMonkey],
            },
        },
    },
    // 2 POTASSIUM
    {
        name: 'Decent Tipper',
        description: 'Instant: Heal a friendly for 2',
        potassium: 2,
        type: __1.GameCardTypes.CREATURE,
        attack: 1,
        health: 2,
        instant: {
            name: 'HealEffect',
            params: {
                value: 2,
            },
            targets: {
                select: __1.TargetSelect.ByPlayer,
                type: [__1.TargetTypes.FriendlyCreature],
            },
        },
    },
    {
        name: 'Jungle Wood Wall',
        description: 'Blocker. Cannot attack',
        potassium: 2,
        attack: 1,
        health: 4,
        attackDisabled: true,
        type: __1.GameCardTypes.CREATURE,
        modifiers: {
            Blocker: true,
        },
    },
    {
        name: 'BRPD Bolici',
        potassium: 2,
        description: 'Blocker',
        attack: 3,
        health: 2,
        type: __1.GameCardTypes.CREATURE,
        modifiers: {
            Blocker: true,
        },
    },
    {
        name: 'Loan Shark',
        description: 'Instant: 1 damage to any enemy',
        potassium: 2,
        attack: 2,
        health: 2,
        type: __1.GameCardTypes.CREATURE,
        instant: {
            name: 'DamageEffect',
            params: {
                value: 1,
            },
            targets: {
                select: __1.TargetSelect.ByPlayer,
                type: [__1.TargetTypes.EnemyCreature, __1.TargetTypes.EnemyMonkey],
            },
            filterDamageModifiers: true,
        },
    },
    {
        name: "Melon's Musk",
        description: 'Give +3/-1 to a card',
        potassium: 2,
        type: __1.GameCardTypes.SPELL,
        gameClass: __1.GameClasses.Memes,
        spell: {
            name: 'BuffEffect',
            params: {
                attack: 3,
                health: -1,
            },
            targets: {
                select: __1.TargetSelect.ByPlayer,
                type: [__1.TargetTypes.FriendlyCreature, __1.TargetTypes.EnemyCreature],
            },
        },
    },
    // 3 POTASSIUM
    {
        name: 'Fat Coco Blocker',
        description: 'Blocker. Cannot attack',
        potassium: 3,
        type: __1.GameCardTypes.CREATURE,
        attack: 2,
        health: 4,
        attackDisabled: true,
    },
    {
        name: 'Corrupt Bolici',
        potassium: 3,
        type: __1.GameCardTypes.CREATURE,
        attack: 4,
        health: 2,
    },
    {
        name: '.brain',
        description: 'Heal each friendly for 1',
        potassium: 3,
        type: __1.GameCardTypes.SPELL,
        spell: {
            name: 'HealEffect',
            params: {
                value: 1,
            },
            targets: {
                select: __1.TargetSelect.Auto,
                type: [__1.TargetTypes.FriendlyCreature],
                count: 'ALL',
            },
        },
    },
    // 4 POTASSIUM
    {
        name: 'Angry Gorilla',
        description: 'Instant: 2 damage to any enemy',
        potassium: 4,
        attack: 3,
        health: 3,
        type: __1.GameCardTypes.CREATURE,
        instant: {
            name: 'DamageEffect',
            params: {
                value: 2,
            },
            targets: {
                select: __1.TargetSelect.ByPlayer,
                type: [__1.TargetTypes.EnemyCreature, __1.TargetTypes.EnemyMonkey],
            },
            filterDamageModifiers: true,
        },
    },
    {
        name: 'Caesar',
        potassium: 4,
        type: __1.GameCardTypes.CREATURE,
        attack: 5,
        health: 3,
    },
    {
        name: 'Serenifty',
        potassium: 4,
        type: __1.GameCardTypes.CREATURE,
        description: 'Give +2/+1 to any friendly',
        attack: 3,
        health: 2,
        instant: {
            name: 'BuffEffect',
            params: {
                attack: 2,
                health: 1,
            },
            targets: {
                select: __1.TargetSelect.ByPlayer,
                type: [__1.TargetTypes.FriendlyCreature],
            },
        },
    },
    {
        name: 'Private Key Bruteforce',
        description: 'Do 4 damage to any enemy',
        potassium: 4,
        type: __1.GameCardTypes.SPELL,
        spell: {
            name: 'DamageEffect',
            params: {
                value: 4,
            },
            targets: {
                select: __1.TargetSelect.ByPlayer,
                type: [__1.TargetTypes.EnemyCreature, __1.TargetTypes.EnemyMonkey],
            },
        },
    },
    // 5 POTASSIUM
    {
        name: 'Benis',
        potassium: 5,
        description: 'Blocker',
        type: __1.GameCardTypes.CREATURE,
        attack: 5,
        health: 4,
        modifiers: {
            Blocker: true,
        },
    },
    {
        name: 'Shitcoin CEO',
        description: 'Instant: Summon 2 1/1 social media influencers',
        potassium: 5,
        type: __1.GameCardTypes.CREATURE,
        attack: 3,
        health: 3,
        instant: {
            name: 'SummonEffect',
            params: {
                name: 'Social Media Influencer',
                count: 2,
            },
        },
    },
    {
        name: 'Social Media Influencer',
        type: __1.GameCardTypes.CREATURE,
        potassium: 0,
        notAddableToDeck: true,
        attack: 1,
        health: 1,
    },
    {
        name: 'Limit Seller',
        type: __1.GameCardTypes.CREATURE,
        potassium: 5,
        attack: 5,
        health: 2,
        modifiers: {
            Monkeshield: true,
        },
    },
    // MEMES
    {
        name: 'Banonus',
        description: 'Summon an impostor of any enemy card on your board (Memes Class)',
        potassium: 3,
        type: __1.GameCardTypes.SPELL,
        gameClass: __1.GameClasses.Memes,
        spell: {
            name: 'SummonEffect',
            targets: {
                select: __1.TargetSelect.ByPlayer,
                type: [__1.TargetTypes.EnemyCreature],
            },
        },
    },
    {
        name: "Banoshi's Blessing",
        description: 'Double the health of any friendly (Memes Class)',
        potassium: 2,
        type: __1.GameCardTypes.SPELL,
        gameClass: __1.GameClasses.Memes,
        spell: {
            name: 'DoubleHealthEffect',
            targets: {
                select: __1.TargetSelect.ByPlayer,
                type: [__1.TargetTypes.FriendlyCreature],
            },
        },
    },
    {
        name: 'EA',
        description: 'Increase cost of all cards in opponent hand by 1 (Memes Class)',
        potassium: 3,
        type: __1.GameCardTypes.SPELL,
        gameClass: __1.GameClasses.Memes,
        spell: {
            name: 'IncreaseCostEffect',
            params: {
                cards: 'ALL',
                value: 1,
                player: 'OPPONENT',
            },
        },
    },
    {
        name: 'Ketamine',
        description: 'Give +4/-1 to a card (Memes Class)',
        potassium: 3,
        type: __1.GameCardTypes.SPELL,
        gameClass: __1.GameClasses.Memes,
        spell: {
            name: 'BuffEffect',
            params: {
                attack: 4,
                health: -1,
            },
            targets: {
                select: __1.TargetSelect.ByPlayer,
                type: [__1.TargetTypes.FriendlyCreature, __1.TargetTypes.EnemyCreature],
            },
        },
    },
    // MOVIES + TV
    {
        name: 'Banos',
        description: "Deal 2 damage to a random half of the opponent's board (Movies+TV Class)",
        potassium: 4,
        type: __1.GameCardTypes.SPELL,
        gameClass: __1.GameClasses.MoviesTV,
        spell: {
            name: 'BanosEffect',
        },
    },
    {
        name: 'Ban Wick',
        description: 'Instant: Deal 1 damage to any enemy (Movies+TV Class)',
        potassium: 5,
        attack: 5,
        health: 4,
        type: __1.GameCardTypes.CREATURE,
        gameClass: __1.GameClasses.MoviesTV,
        instant: {
            name: 'DamageEffect',
            params: {
                value: 1,
            },
            targets: {
                select: __1.TargetSelect.ByPlayer,
                type: [__1.TargetTypes.EnemyCreature, __1.TargetTypes.EnemyMonkey],
            },
            filterDamageModifiers: true,
        },
    },
    {
        name: 'The Twins',
        description: 'Summon two 1/1 twins (Movies+TV Class)',
        potassium: 2,
        type: __1.GameCardTypes.SPELL,
        gameClass: __1.GameClasses.MoviesTV,
        spell: {
            name: 'SummonEffect',
            params: {
                count: 2,
                name: 'Twin',
            },
        },
    },
    {
        name: 'Twin',
        description: '',
        potassium: 0,
        attack: 1,
        health: 1,
        type: __1.GameCardTypes.CREATURE,
        notAddableToDeck: true,
    },
    // FESTIVE
    {
        name: 'Big Spook',
        type: __1.GameCardTypes.SPELL,
        gameClass: __1.GameClasses.Festive,
        description: 'Give FUD +1 to any enemy creature (Festive Class)',
        potassium: 2,
        spell: {
            name: 'ModifierEffect',
            params: {
                modifier: 'FUD',
                value: 1,
            },
            targets: {
                select: __1.TargetSelect.ByPlayer,
                type: [__1.TargetTypes.EnemyCreature],
            },
        },
    },
];
